<ng-container *ngIf="viewModel$ | async as vm">
  <app-dashboard-shell
    title="System Revenue"
    [lastReload]="vm.lastReload"
    [loading]="vm.loading"
    [showRefresh]="true"
    (refresh)="triggerReload()"
    class="system-revenue-container"
  >
    <div class="p-col-12">
      <div class="dashboard-card">
        <div class="dashboard-card-header p-mb-3">
          <div>
            <div class="title-row">
              <h4 class="p-mb-0">
                Revenue by franchise<app-error-icon
                  *ngIf="vm.error"
                  [error]="vm.error"
                ></app-error-icon>
              </h4>
              <app-dashboard-info-v2>
                <div class="p-mb-2">
                  Revenue and activity breakdown by franchise for events ending in
                  the selected period.
                </div>
                <div class="p-mb-2">
                  <a
                    [routerLink]="['/reports', 'dynamic', 'new']"
                    [queryParams]="vm.queryParams"
                    target="_blank"
                    >View Report</a
                  >.
                </div>
              </app-dashboard-info-v2>
            </div>
          </div>
          <p-splitButton
            label="Copy Data"
            icon="pi pi-copy"
            (onClick)="vm.copyToClipboard()"
            [model]="vm.actions"
            [disabled]="vm.loading"
            appendTo="body"
          ></p-splitButton>
        </div>

        <p-blockUI
          [target]="systemRevenueTable"
          [blocked]="vm.loading"
          [autoZIndex]="false"
        >
          <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
        </p-blockUI>

        <app-blockable #systemRevenueTable>
          <div class="table-scroll" *ngIf="!vm.isEmpty">
            <table class="events-table">
              <thead>
                <tr>
                  <th *ngFor="let header of vm.headers">{{ header }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of vm.rows" [class]="'row-' + row.kind">
                  <td *ngFor="let cell of row.cells">
                    <ng-container
                      *ngIf="$any(cell).routerLink as routerLink; else plainCell"
                    >
                      <span
                        class="freya-link-button"
                        [routerLink]="routerLink"
                        [queryParams]="$any(cell).queryParams"
                        >{{ $any(cell).text }}</span
                      >
                    </ng-container>
                    <ng-template #plainCell>{{ cell }}</ng-template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <app-dashboard-empty-state
            *ngIf="vm.isEmpty"
            text="No revenue activity in the selected period"
          ></app-dashboard-empty-state>
        </app-blockable>
      </div>
    </div>
  </app-dashboard-shell>
</ng-container>
